export function getHost(): string {
  // return "http://192.168.1.102:5000/api/v1";
  return "/api/v1";
}
